import { useCallback, useEffect, useRef } from 'react';
import axios from '../../library/axios';
import { dispatchCpanelFeedRefresh } from '../../helpers/cpanelJobFeedback';
import { mapNotificationToToast, showCpanelToast } from '../../helpers/cpanelToast';

const POLL_INTERVAL_MS = 5000;

const CpanelNotificationRealtime = () => {
  const seenIdsRef = useRef(new Set());
  const bootstrappedRef = useRef(false);

  const pollNewNotifications = useCallback(async () => {
    try {
      const { data } = await axios.get('/cpanel/notifications/list', {
        params: { tab: 'all', limit: 20 },
      });

      const list = Array.isArray(data?.notifications) ? data.notifications : [];

      if (!bootstrappedRef.current) {
        list.forEach((item) => seenIdsRef.current.add(item.id));
        bootstrappedRef.current = true;
        return;
      }

      const freshItems = list
        .filter((item) => !seenIdsRef.current.has(item.id))
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

      if (!freshItems.length) {
        return;
      }

      freshItems.forEach((item) => {
        seenIdsRef.current.add(item.id);
        showCpanelToast(mapNotificationToToast(item));
      });

      dispatchCpanelFeedRefresh();
    } catch {
      // ignore polling errors
    }
  }, []);

  useEffect(() => {
    pollNewNotifications();
    const timer = window.setInterval(pollNewNotifications, POLL_INTERVAL_MS);

    return () => {
      window.clearInterval(timer);
    };
  }, [pollNewNotifications]);

  return null;
};

export default CpanelNotificationRealtime;
